import { render, staticRenderFns } from "./CreateFollow.vue?vue&type=template&id=279951ae&scoped=true&"
import script from "./CreateFollow.vue?vue&type=script&lang=js&"
export * from "./CreateFollow.vue?vue&type=script&lang=js&"
import style0 from "./CreateFollow.vue?vue&type=style&index=0&id=279951ae&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "279951ae",
  null
  
)

export default component.exports